import enSearch from "./en";
import frSearch from "./fr";
import deSearch from "./de";

export { enSearch, frSearch, deSearch };
